<template>
  <div class="order-card">
    <div class="order-container">
      <div class="order-image">
        <img :src="itemDetail.imageInfo.imageUrl" />
      </div>
      <div class="order-details">
        <div class="title">
          {{ itemDetail.itemName }}
        </div>
        <div>{{ getCurrency(itemDetail.modelOriginalPrice) }}</div>
        <div>option</div>
        <div>
          Model Name:{{ itemDetail.modelName }}
          <b-button
            variant="copy-clipboard"
            v-b-tooltip.hover
            :title="tooltipText"
            @click.stop.prevent="onCopy('MAMA-0001')"
            @mouseout="outCopyClipboard"
          >
            <font-awesome-icon icon="copy" />
          </b-button>
        </div>
        <!-- <div class="rating">*****</div> -->
      </div>
    </div>
    <div class="order-price">
      <div>{{ getCurrency(itemDetail.modelOriginalPrice) }}</div>
      <div>x{{ itemDetail.modelQuantityPurchased }}</div>
    </div>
  </div>
</template>

<script>
import getCurrencyByMode from "@/helpers/getCurrencyByMode";
export default {
  name: "OrderCard",
  props: {
    itemDetail: {
      required: true,
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      tooltipText: "",
      imageUrl: "https://cf.shopee.co.th/file/sg-11134201-7rdxg-mcagrnb0awt510"
    };
  },
  methods: {
    onCopy(text) {
      navigator.clipboard
        .writeText(text)
        .then(() => {
          this.tooltipText = this.$t("copySuccess");
        })
        .catch(err => {
          console.error("Error in copying text: ", err);
        });
    },
    outCopyClipboard() {
      this.tooltipText = this.$t("copy");
    },
    getCurrency(amount) {
      const MODE = process.env.VUE_APP_MODE;
      return getCurrencyByMode(amount, MODE);
    }
  }
};
</script>

<style lang="scss" scoped>
.order-card {
  background-color: #fff;
  display: flex;
  width: 100%;
  font-size: 14px;

  .order-container {
    display: flex;
    flex: 1;
    width: 90%;

    .order-image {
      width: 60px;
      height: 60px;
      flex-shrink: 0;
      overflow: hidden;
      border: 1px solid #f1f1f1;

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }

    .order-details {
      flex: 1;
      padding: 0px 5px;
      width: 100%;

      .title {
        font-weight: 600;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        width: 80%;
      }

      div:not(.title) {
        color: #9c9c9c;
        font-size: 14px;
      }

      .btn-copy-clipboard {
        padding: 0;
        color: #832abf;
        cursor: pointer;
        font-size: 10px;
        margin-bottom: 2px;
      }
    }
  }

  .order-price {
    width: 100%;
    margin-right: 50px;
    div:last-child {
      color: #9c9c9c;
    }
  }
}
</style>
